import React from 'react';
import { Link } from 'react-router-dom';

const Rebrand = () => {
  return (
    <div className="min-h-screen py-16">
      {/* Hero Section */}
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Launch your <span className="text-[#22c55e]">Digital Empire</span> with OLYMP
        </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Start your successful digital business with our proven automated shop system
          </p>
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
            {/* Animated corner effects */}
            <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            
            <div className="relative">
              <div className="text-[#22c55e] text-5xl font-bold mb-2 transform transition-all duration-500 group-hover:scale-110 group-hover:text-[#22c55e] flex justify-center items-baseline">
                2000
                <span className="text-3xl ml-1">+</span>
              </div>
              <div className="text-gray-300 group-hover:text-white transition-colors duration-500">Satisfied Customers</div>
            </div>
          </div>

          <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
            {/* Animated corner effects */}
            <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            
            <div className="relative">
              <div className="text-[#22c55e] text-5xl font-bold mb-2 transform transition-all duration-500 group-hover:scale-110 group-hover:text-[#22c55e] flex justify-center items-baseline">
                <span className="text-3xl mr-1">$</span>3-5K
              </div>
              <div className="text-gray-300 group-hover:text-white transition-colors duration-500">Monthly Revenue</div>
            </div>
          </div>

          <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
            {/* Animated background glow */}
            <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
            {/* Animated corner effects */}
            <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
            
            <div className="relative">
              <div className="text-[#22c55e] text-5xl font-bold mb-2 transform transition-all duration-500 group-hover:scale-110 group-hover:text-[#22c55e] flex justify-center items-baseline">
                50
                <span className="text-3xl ml-1">+</span>
              </div>
              <div className="text-gray-300 group-hover:text-white transition-colors duration-500">Trusted Suppliers</div>
            </div>
          </div>
        </div>

        {/* Main Benefits Table */}
        <div className="glass-card p-8 mb-16">
          <h2 className="text-2xl font-bold text-white mb-8 text-center">What You'll Get With Our Training</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">All Our Methods</h3>
                  <p className="text-gray-300">Access to our complete business strategies and proven methods</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">Premium Supplier Network</h3>
                  <p className="text-gray-300">Direct access to our network of 50+ trusted suppliers</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">Custom Discord Server</h3>
                  <p className="text-gray-300">Fully setup server with custom embeds and sales optimization</p>
                </div>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">Custom Shop Design</h3>
                  <p className="text-gray-300">Unique and professional design tailored to your brand</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">Custom Website</h3>
                  <p className="text-gray-300">Unique and professional website tailored to your brand</p>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 w-6 h-6 text-[#22c55e] mt-1">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-white font-semibold">Custom Helper Bot</h3>
                  <p className="text-gray-300">Dedicated bot to assist with your sales and customer service</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Why Choose Us */}
        <div className="mb-16">
          <h2 className="text-2xl font-bold text-white mb-8 text-center">Your Success, Our Priority</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
              {/* Animated background glow */}
              <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
              {/* Animated corner effects */}
              <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              
              <div className="relative">
                <div className="w-16 h-16 mx-auto mb-4 text-[#22c55e] transform transition-all duration-500 group-hover:scale-110">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </div>
                <h3 className="text-white font-semibold mb-2 transform transition-all duration-500 group-hover:text-[#22c55e]">Proven Track Record</h3>
                <p className="text-gray-300 group-hover:text-white transition-colors duration-500">Join to get 2000+ Satisfied Customers</p>
              </div>
            </div>

            <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
              {/* Animated background glow */}
              <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
              {/* Animated corner effects */}
              <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              
              <div className="relative">
                <div className="w-16 h-16 mx-auto mb-4 text-[#22c55e] transform transition-all duration-500 group-hover:scale-110">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <h3 className="text-white font-semibold mb-2 transform transition-all duration-500 group-hover:text-[#22c55e]">Elite Community</h3>
                <p className="text-gray-300 group-hover:text-white transition-colors duration-500">Network with successful entrepreneurs</p>
              </div>
            </div>

            <div className="glass-card p-8 text-center relative group overflow-hidden transition-all duration-500 hover:scale-105">
              {/* Animated background glow */}
              <div className="absolute inset-0 bg-[#22c55e]/5 blur-xl group-hover:bg-[#22c55e]/10 transition-all duration-500"></div>
              {/* Animated corner effects */}
              <div className="absolute top-0 left-0 w-16 h-16 bg-gradient-to-br from-[#22c55e]/20 to-transparent transform -translate-x-full -translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              <div className="absolute bottom-0 right-0 w-16 h-16 bg-gradient-to-tl from-[#22c55e]/20 to-transparent transform translate-x-full translate-y-full group-hover:translate-x-0 group-hover:translate-y-0 transition-transform duration-700"></div>
              
              <div className="relative">
                <div className="w-16 h-16 mx-auto mb-4 text-[#22c55e] transform transition-all duration-500 group-hover:scale-110">
                  <svg fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                  </svg>
                </div>
                <h3 className="text-white font-semibold mb-2 transform transition-all duration-500 group-hover:text-[#22c55e]">Trusted Methods</h3>
                <p className="text-gray-300 group-hover:text-white transition-colors duration-500">100% legal and reliable system</p>
              </div>
            </div>
          </div>
        </div>

        {/* Pricing Section */}
        <div className="mb-16 relative">
          {/* Background glow effects */}
          <div className="absolute inset-0 bg-[#22c55e]/5 blur-[100px] rounded-full transform animate-pulse"></div>
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-[#22c55e]/10 blur-[120px] rounded-full transform animate-pulse"></div>
          
          <div className="relative max-w-2xl mx-auto p-8">
            {/* Floating orbs */}
            <div className="absolute top-0 left-0 w-32 h-32 bg-gradient-to-r from-[#22c55e]/30 to-transparent rounded-full blur-2xl animate-float"></div>
            <div className="absolute bottom-0 right-0 w-40 h-40 bg-gradient-to-l from-[#22c55e]/20 to-transparent rounded-full blur-2xl animate-float-delayed"></div>
            
            <h2 className="text-4xl font-bold text-white mb-12 relative text-center">
              <span className="bg-clip-text text-transparent bg-gradient-to-r from-[#22c55e] to-[#15803d] animate-gradient">Limited Time Offer</span>
            </h2>

            <div className="flex justify-center items-center mb-12 relative group">
              {/* Price glow effect */}
              <div className="absolute inset-0 bg-gradient-to-r from-[#22c55e]/20 via-[#22c55e]/10 to-transparent blur-3xl rounded-full transform group-hover:scale-110 transition-transform duration-500"></div>
              
              <div className="relative flex items-center group-hover:scale-105 transition-transform duration-300">
                <span className="text-8xl font-bold text-[#22c55e] group-hover:animate-pulse">€329</span>
                <div className="ml-2">
                  <span className="text-4xl font-bold text-[#22c55e]">.99</span>
                  <div className="text-gray-400 text-lg mt-1">one-time payment</div>
                </div>
              </div>
            </div>

            <div className="space-y-6 mb-12 relative">
              {/* Features with floating animation */}
              {[
                "Complete Business Setup Within 24h",
                "Premium Features & Tools Included",
                "Lifetime Updates & Support"
              ].map((feature, index) => (
                <div key={index} 
                  className="flex items-center justify-center text-gray-300 hover:text-white transition-colors duration-300 group"
                  style={{
                    animation: `float ${3 + index * 0.5}s ease-in-out infinite alternate`
                  }}
                >
                  <div className="w-6 h-6 mr-3 text-[#22c55e] transform group-hover:scale-110 transition-transform duration-300">
                    <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" className="group-hover:animate-bounce">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                    </svg>
                  </div>
                  <span className="text-lg">{feature}</span>
                </div>
              ))}
            </div>

            {/* Animated CTA button */}
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-[#22c55e] via-[#15803d] to-[#22c55e] rounded-full blur-xl opacity-70 group-hover:opacity-100 transition duration-1000 group-hover:duration-200 animate-pulse"></div>
              <a
                href="https://discord.gg/olymp4"
                target="_blank"
                rel="noopener noreferrer"
                className="relative flex items-center justify-center px-12 py-6 bg-gradient-to-r from-black/80 to-black/60 backdrop-blur-sm rounded-full leading-none border border-[#22c55e]/20 group-hover:border-[#22c55e]/40 transition-all duration-300"
              >
                <div className="absolute inset-0 rounded-full bg-gradient-to-r from-[#22c55e]/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <span className="text-[#22c55e] text-2xl font-medium group-hover:text-white transition-colors duration-300 flex items-center">
                  Get Started Now
                  <svg className="w-6 h-6 ml-3 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
                  </svg>
                </span>
              </a>
            </div>

            <div className="mt-8 text-gray-400 flex items-center justify-center space-x-2 animate-float">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-11a1 1 0 10-2 0v3.586L7.707 9.293a1 1 0 00-1.414 1.414l3 3a1 1 0 001.414 0l3-3a1 1 0 00-1.414-1.414L11 10.586V7z" clipRule="evenodd" />
              </svg>
              <span>Limited time offer - Price will increase soon</span>
            </div>
          </div>
        </div>

        <style jsx>{`
          @keyframes float {
            0% { transform: translateY(0px); }
            100% { transform: translateY(-10px); }
          }
          @keyframes float-delayed {
            0% { transform: translateY(-10px); }
            100% { transform: translateY(0px); }
          }
        `}</style>
      </div>
    </div>
  );
};

export default Rebrand; 